module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8565/img/favicon-dark.png"